export const VENDOR_LOGIN_PATH = "/login/vendor";

/** Must match URL_FRONTEND_VENDOR_RESET base path used by MS Login in reset emails. */
export const VENDOR_PASSWORD_RESET_PATH = "/recupero-password";

/**
 * Prima impostazione della password: stesso flusso (e stesso token) del recupero, ma per
 * gli account vendor creati prima della messa in produzione del portale, che una password
 * non l'hanno mai avuta. Cambiano solo i testi: "reimposta" li confonderebbe.
 */
export const VENDOR_PASSWORD_SETUP_PATH = "/imposta-password";
